export { FileDropModule } from './src/file-drop-module';
export { FileDropDirective } from './src/file-drop.directive';
//# sourceMappingURL=file-drop.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bergben-angular2-file-drop/dist/file-drop.js
// module id = ./node_modules/bergben-angular2-file-drop/dist/file-drop.js
// module chunks = vendor